import { Link } from 'react-router-dom';
import { LanguageSwitch } from '../../app/language-switch';
import { useLanguage } from '../../core/hooks/use-language';
import { useTranslation } from '../../core/hooks/use-translation';
import { BrandLogo } from '../home/brand-logo';
import { ChevronLeftIcon } from './booking-icons';

/**
 * The booking page's own header: the mark, the language switch and a way back. Deliberately not the
 * site header — a wizard's chrome offers no navigation out of it beyond the one door, which is what
 * the live page does and what keeps a customer three fields into a form from wandering off it.
 */
export function BookingHeader() {
    const { t } = useTranslation();
    const language = useLanguage();

    return (
        <header className="hdr">
            <div className="hdr-in">
                <Link to={`/${language}`} className="logo">
                    <BrandLogo />
                </Link>

                <div className="hdr-actions">
                    <LanguageSwitch />
                    <Link to={`/${language}`} className="btn-back">
                        <ChevronLeftIcon />
                        <span>{t('booking.nav.back')}</span>
                    </Link>
                </div>
            </div>
        </header>
    );
}
